import { usePodcastProvider } from "./PodcastProvider";
//ui
import { Box, Grid, GridItem, Stack, Skeleton } from "@chakra-ui/react";
import { PodcastFilter } from "./PodcastFilter";
import { PodcastEpisodeTile } from "./PodcastEpisodeTile";

export function PodcastGrid() {
  const { filteredData, isOpen } = usePodcastProvider();

  const data = filteredData ?? [];

  const showComponents = isOpen ? "none" : "block";

  return (
    <Box width="100%" display={{ base: showComponents, md: "block" }}>
      <PodcastFilter />
      <Box maxWidth="1384px" width="100%" margin="auto" pb={{ base: "244px", sm: "132px" }} px={{ base: "39px", sm: "32px" }}>
        <Grid templateColumns={{ base: "repeat(1, 1fr)", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }} gap={{ base: "18px", sm: "33px 24px" }}>
          {data.map(episode => {
            return (
              <GridItem w="100%" key={episode.episode_number}>
                <PodcastEpisodeTile data={episode} />
              </GridItem>
            );
          })}
          {data.length <= 0 && (
            <>
              {Array.from(Array(4).keys()).map(item => {
                return (
                  <GridItem w="100%" key={item}>
                    <Stack width="100%">
                      <Skeleton height="352px" borderRadius="12px"></Skeleton>
                    </Stack>
                  </GridItem>
                );
              })}
            </>
          )}
        </Grid>
      </Box>
    </Box>
  );
}
